var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wall-container"},on:{"paste":function($event){$event.stopPropagation();return _vm.handleOnPaste($event)}}},[(_vm.xHeader)?_c('surface-header'):_vm._e(),_vm._v(" "),_c('div',{ref:"wishList",class:[
      'wish-list',
      ("background-luminance-" + _vm.backgroundLuminance),
      {
        'scrollbar-photo': _vm.backgroundLuminance === 'light',
        'scrollbar-photo-dark': _vm.backgroundLuminance === 'dark',
      } ],attrs:{"id":"wish-list","dir":_vm.dir}},[_c('surface-sections')],1),_vm._v(" "),_c('div',{staticClass:"wish-sizer"}),_vm._v(" "),_c('div',{staticClass:"gutter-sizer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }